// @flow
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../../../assets/styles/colors';
import {Grid, Typography, Chip, Divider, Paper} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  paperWrap: {
    background: 'white',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    maxWidth: '354px',
    padding: theme.spacing(2),
  },
  title: {
    color: colors.grey900,
    fontSize: '16px',
  },
  chipPayment: {
    backgroundColor: colors.success,
    color: 'white',
  },
  body: {
    color: colors.grey800,
    fontSize: '16px',
  },

  divider: {
    margin: theme.spacing(2, 0),
    background: colors.grey300,
  },
  body2: {
    color: colors.grey800,
    fontSize: '14px',
  },
  gridItem: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(1, 0),
  },
  moneySection: {
    color: colors.grey900,
    fontSize: '16px',
    textAlign: 'right',
  },
}));

export default function CardReceipt() {
  const classes = useStyles();

  return (
    <Paper className={classes.paperWrap}>
      <Grid container justify="center">
        <Grid item md={12} xs={12} sm={12} lg={12} className={classes.gridItem}>
          <Typography className={classes.title}> Junio 2020</Typography>
          <Chip className={classes.chipPayment} label="Pagado" />
        </Grid>
        <Grid item md={12} xs={12} sm={12} lg={12} className={classes.gridItem}>
          <Typography className={classes.body}> Boleta de venta</Typography>
          <Typography className={classes.body}> BX01-534422</Typography>
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid item md={6} xs={6} sm={6}>
          <Typography className={classes.body2}>
            Servicio de tienda virtual. Plan emprendedor
          </Typography>
        </Grid>
        <Grid item md={6} xs={6} sm={6}>
          <Typography className={classes.moneySection}> S/. 35.50</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}
